import { AlertTriangle, Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useState } from "react";

// Reusable destructive-action confirmation dialog. NEVER uses window.confirm.
//
// Usage:
//   const [openDel, setOpenDel] = useState(false);
//   <ConfirmDialog
//     open={openDel}
//     onOpenChange={setOpenDel}
//     title="Delete this camp?"
//     description="This action cannot be undone."
//     confirmLabel="Delete"
//     onConfirm={async () => { await adminApi.delete(...); }}
//   />
export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  destructive = true,
  onConfirm,
}) {
  const [working, setWorking] = useState(false);

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (working) return;
    setWorking(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setWorking(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => !working && onOpenChange(o)}>
      <AlertDialogContent className="bg-zinc-950 border-white/10">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-white">
            {destructive && <AlertTriangle className="w-5 h-5 text-burns-red" />}
            {title}
          </AlertDialogTitle>
          {description && (
            <AlertDialogDescription className="text-zinc-400">
              {description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="bg-transparent border-white/20 text-white hover:bg-white/5"
            disabled={working}
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={working}
            className={
              destructive
                ? "bg-burns-red hover:bg-burns-red/80 text-white"
                : "bg-burns-gold hover:bg-burns-gold/80 text-black"
            }
          >
            {working ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
